import {StemDate} from "../../stem-core/time/Date";
import {TimeUnit} from "../../stem-core/time/Duration";
import {Toast} from "../../blinkpay/ui/Toast";

const DATE_WITHOUT_YEAR = "MMM DD";
const DATE_WITH_YEAR = "MMM DD, YYYY";

export function CopyTextToClipboard(text: string) {
    // TODO: maybe use document.execCommand("copy") if this prompts a pop-up
    navigator.clipboard.writeText(text);
    Toast.show("Copied to clipboard");
}

// TODO do a better job with date formatting
// Not a plain Date: the assignment below has to narrow to StemDate for the calls that follow
export function formatDate(date: StemDate | string | number, includingHour: boolean) {
    date = new StemDate(date);
    const dateFormat = (date.isSame(new StemDate(), TimeUnit.YEAR) ? DATE_WITHOUT_YEAR : DATE_WITH_YEAR) +
        (includingHour ? " HH:mm AA" : ""); // TODO custom hour format
    return date.format(dateFormat);
}

export function formatDateWithHour(date: StemDate | string | number) {
    return formatDate(date, true);
}

export function formatDateRange(startDate: StemDate | string | number, endDate: StemDate | string | number) {
    startDate = new StemDate(startDate);
    endDate = new StemDate(endDate);

    const sameYear = startDate.isSame(endDate, TimeUnit.YEAR);
    const bothCurrentYear = sameYear && startDate.isSame(new StemDate(), TimeUnit.YEAR);

    const endDateFormat = bothCurrentYear ? DATE_WITHOUT_YEAR : DATE_WITH_YEAR;
    const startDateFormat = sameYear ? DATE_WITHOUT_YEAR : DATE_WITH_YEAR;

    if (startDate.isSame(endDate, TimeUnit.DAY)) {
        return endDate.format(endDateFormat);
    }

    return `${startDate.format(startDateFormat)} - ${endDate.format(endDateFormat)}`;
}
